export const movies = [
  {
    id: 1,
    title: '星际穿越',
    titleEn: 'Interstellar',
    slug: 'interstellar',
    category: 'sci-fi',
    categoryName: '科幻巨制',
    year: 2014,
    rating: 9.4,
    director: '克里斯托弗·诺兰',
    cast: '马修·麦康纳、安妮·海瑟薇、杰西卡·查斯坦',
    duration: '169分钟',
    description: '在不远的未来，地球面临着严重的环境危机，人类生存受到威胁。前NASA飞行员库珀被选中参与一项穿越虫洞的星际旅行计划，前往另一个星系寻找人类的新家园。这部电影以严谨的科学理论为基础，融合了父女之间深沉的情感纽带，诺兰用宏大的宇宙视角和细腻的人物刻画，呈现了一场关于爱、时间和人类命运的史诗级科幻巨制。',
    image: 'https://readdy.ai/api/search-image?query=Interstellar%20movie%20poster%20style%2C%20astronaut%20floating%20near%20black%20hole%20in%20deep%20space%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20cold%20blue%20and%20warm%20orange%20color%20contrast%2C%20epic%20scale%2C%20film%20grain%20texture%2C%20minimalist%20design%2C%20dark%20background%20with%20stars&width=800&height=1200&seq=movie-interstellar&orientation=portrait',
    featured: true,
  },
  {
    id: 2,
    title: '盗梦空间',
    titleEn: 'Inception',
    slug: 'inception',
    category: 'sci-fi',
    categoryName: '科幻巨制',
    year: 2010,
    rating: 9.3,
    director: '克里斯托弗·诺兰',
    cast: '莱昂纳多·迪卡普里奥、约瑟夫·高登-莱维特、艾伦·佩吉',
    duration: '148分钟',
    description: '多姆·柯布是一位专门从他人梦境中窃取秘密的"盗梦者"。为了回到自己的孩子身边，他接受了一项看似不可能完成的任务——在目标对象的潜意识深处植入一个想法，即"奠基"。随着梦境层层深入，现实与梦境的界限变得模糊不清。诺兰通过精巧的多层叙事结构，构建了一个令人叹为观止的梦境世界。',
    image: 'https://readdy.ai/api/search-image?query=Inception%20movie%20poster%20style%2C%20city%20streets%20folding%20upwards%20in%20dream%20sequence%2C%20surreal%20architecture%2C%20cinematic%20lighting%2C%20dark%20moody%20tone%2C%20film%20noir%20aesthetic%2C%20minimalist%20composition%2C%20deep%20shadows&width=800&height=1200&seq=movie-inception&orientation=portrait',
    featured: true,
  },
  {
    id: 3,
    title: '黑暗骑士',
    titleEn: 'The Dark Knight',
    slug: 'the-dark-knight',
    category: 'action',
    categoryName: '动作大片',
    year: 2008,
    rating: 9.2,
    director: '克里斯托弗·诺兰',
    cast: '克里斯蒂安·贝尔、希斯·莱杰、艾伦·艾克哈特',
    duration: '152分钟',
    description: '蝙蝠侠、戈登警长和检察官哈维·丹特联手打击哥谭市的有组织犯罪。然而，一个自称"小丑"的犯罪天才出现，将哥谭市推入了前所未有的混乱之中。希斯·莱杰贡献了影史最伟大的反派表演之一，将一个癫狂、混乱、难以捉摸的角色演绎得淋漓尽致。诺兰将超级英雄类型片提升到了前所未有的艺术高度。',
    image: 'https://readdy.ai/api/search-image?query=The%20Dark%20Knight%20movie%20poster%20style%2C%20batman%20silhouette%20against%20burning%20city%20skyline%2C%20dark%20dramatic%20atmosphere%2C%20orange%20fire%20and%20smoke%2C%20cinematic%20composition%2C%20gritty%20urban%20texture%2C%20minimalist%20hero%20design&width=800&height=1200&seq=movie-dark-knight&orientation=portrait',
    featured: true,
  },
  {
    id: 4,
    title: '肖申克的救赎',
    titleEn: 'The Shawshank Redemption',
    slug: 'shawshank-redemption',
    category: 'drama',
    categoryName: '经典剧情',
    year: 1994,
    rating: 9.7,
    director: '弗兰克·德拉邦特',
    cast: '蒂姆·罗宾斯、摩根·弗里曼',
    duration: '142分钟',
    description: '银行家安迪·杜弗雷因被冤枉谋杀妻子及其情人而被判处终身监禁，关进了肖申克监狱。在漫长的监狱岁月中，他凭借自己的才智和毅力，不仅赢得了狱友的尊重，更在暗中策划了一场惊天越狱。这部关于希望、友谊和自由的电影，被誉为影史最伟大的作品之一。',
    image: 'https://readdy.ai/api/search-image?query=The%20Shawshank%20Redemption%20movie%20poster%20style%2C%20man%20standing%20in%20rain%20with%20arms%20outstretched%2C%20dramatic%20freedom%20moment%2C%20dark%20stormy%20sky%20with%20light%20breaking%20through%2C%20cinematic%20lighting%2C%20emotional%20powerful%20scene%2C%20minimalist%20composition&width=800&height=1200&seq=movie-shawshank&orientation=portrait',
    featured: true,
  },
  {
    id: 5,
    title: '阿凡达',
    titleEn: 'Avatar',
    slug: 'avatar',
    category: 'sci-fi',
    categoryName: '科幻巨制',
    year: 2009,
    rating: 8.8,
    director: '詹姆斯·卡梅隆',
    cast: '萨姆·沃辛顿、佐伊·索尔达娜、西格妮·韦弗',
    duration: '162分钟',
    description: '前海军陆战队员杰克·萨利来到潘多拉星球，参与"阿凡达"计划。通过基因改造，他能够操控一个纳美人混血身体，深入这个外星文明的世界。在与纳美人的相处中，杰克逐渐爱上了这个种族和他们的生活方式，最终选择站在他们一边对抗人类的入侵。卡梅隆用划时代的视觉技术，创造了一个令人叹为观止的外星世界。',
    image: 'https://readdy.ai/api/search-image?query=Avatar%20movie%20poster%20style%2C%20blue%20alien%20face%20with%20glowing%20forest%20background%2C%20bioluminescent%20plants%2C%20mystical%20atmosphere%2C%20cinematic%20composition%2C%20fantasy%20sci-fi%20aesthetic%2C%20ethereal%20lighting%2C%20minimalist%20design&width=800&height=1200&seq=movie-avatar&orientation=portrait',
    featured: false,
  },
  {
    id: 6,
    title: '泰坦尼克号',
    titleEn: 'Titanic',
    slug: 'titanic',
    category: 'romance',
    categoryName: '爱情经典',
    year: 1997,
    rating: 9.4,
    director: '詹姆斯·卡梅隆',
    cast: '莱昂纳多·迪卡普里奥、凯特·温斯莱特',
    duration: '194分钟',
    description: '1912年，穷画家杰克和贵族少女罗丝在泰坦尼克号上相遇并坠入爱河。然而，巨轮与冰山相撞，这场跨越阶级的爱情面临着生死考验。卡梅隆用宏大的制作规模和细腻的情感刻画，将一段刻骨铭心的爱情故事与历史灾难完美融合，创造了影史票房奇迹。',
    image: 'https://readdy.ai/api/search-image?query=Titanic%20movie%20poster%20style%2C%20couple%20embracing%20at%20ship%20bow%20at%20sunset%2C%20romantic%20dramatic%20atmosphere%2C%20golden%20hour%20lighting%2C%20cinematic%20composition%2C%20vintage%20aesthetic%2C%20epic%20romance%20feel&width=800&height=1200&seq=movie-titanic&orientation=portrait',
    featured: false,
  },
  {
    id: 7,
    title: '搏击俱乐部',
    titleEn: 'Fight Club',
    slug: 'fight-club',
    category: 'thriller',
    categoryName: '悬疑惊悚',
    year: 1999,
    rating: 9.0,
    director: '大卫·芬奇',
    cast: '布拉德·皮特、爱德华·诺顿、海伦娜·伯翰·卡特',
    duration: '139分钟',
    description: '一个患有失眠症的普通白领遇到了自由奔放的肥皂商人泰勒·德顿，两人创立了一个地下搏击俱乐部，并迅速演变成一场无政府主义运动。然而随着事态发展，真相变得越来越扑朔迷离。大卫·芬奇用犀利的视觉风格和令人震惊的剧情反转，探讨了消费主义、男性身份认同和社会异化等深刻主题。',
    image: 'https://readdy.ai/api/search-image?query=Fight%20Club%20movie%20poster%20style%2C%20two%20men%20fighting%20in%20underground%20basement%20with%20dramatic%20lighting%2C%20gritty%20raw%20atmosphere%2C%20dark%20shadows%2C%20cinematic%20composition%2C%20urban%20decay%20aesthetic%2C%20minimalist%20design&width=800&height=1200&seq=movie-fight-club&orientation=portrait',
    featured: false,
  },
  {
    id: 8,
    title: '黑客帝国',
    titleEn: 'The Matrix',
    slug: 'the-matrix',
    category: 'sci-fi',
    categoryName: '科幻巨制',
    year: 1999,
    rating: 9.1,
    director: '沃卓斯基姐妹',
    cast: '基努·里维斯、劳伦斯·菲什伯恩、凯瑞-安·莫斯',
    duration: '136分钟',
    description: '程序员尼奥发现自己生活的世界并非真实，而是由人工智能创造的虚拟现实——"矩阵"。在墨菲斯的引导下，他加入了人类反抗军，踏上了拯救人类的征途。这部电影重新定义了科幻动作片的美学标准，"子弹时间"等视觉特效至今仍被广泛模仿和致敬。',
    image: 'https://readdy.ai/api/search-image?query=The%20Matrix%20movie%20poster%20style%2C%20person%20in%20black%20trench%20coat%20dodging%20bullets%20with%20green%20digital%20rain%20background%2C%20cyberpunk%20aesthetic%2C%20dark%20atmosphere%2C%20cinematic%20composition%2C%20futuristic%20tech%20feel&width=800&height=1200&seq=movie-matrix&orientation=portrait',
    featured: true,
  },
  {
    id: 9,
    title: '教父',
    titleEn: 'The Godfather',
    slug: 'the-godfather',
    category: 'drama',
    categoryName: '经典剧情',
    year: 1972,
    rating: 9.5,
    director: '弗朗西斯·福特·科波拉',
    cast: '马龙·白兰度、阿尔·帕西诺、詹姆斯·肯恩',
    duration: '175分钟',
    description: '维托·柯里昂是纽约最有权势的黑手党家族首领。在女儿婚礼当天，他拒绝了毒贩索洛佐的合作请求，引发了一场血腥的黑帮战争。小儿子迈克尔从不愿涉足家族生意到被迫成为新一代"教父"，经历了蜕变性的人物弧光。科波拉将黑帮题材上升到了关于家庭、权力和美国梦的史诗高度。',
    image: 'https://readdy.ai/api/search-image?query=The%20Godfather%20movie%20poster%20style%2C%20man%20in%20tuxedo%20holding%20a%20red%20rose%2C%20classic%20dark%20dramatic%20atmosphere%2C%20vintage%20film%20aesthetic%2C%20warm%20golden%20and%20deep%20shadow%20lighting%2C%20mafia%20elegance%2C%20minimalist%20composition&width=800&height=1200&seq=movie-godfather&orientation=portrait',
    featured: false,
  },
  {
    id: 10,
    title: '侏罗纪公园',
    titleEn: 'Jurassic Park',
    slug: 'jurassic-park',
    category: 'action',
    categoryName: '动作大片',
    year: 1993,
    rating: 8.9,
    director: '史蒂文·斯皮尔伯格',
    cast: '萨姆·尼尔、劳拉·邓恩、杰夫·高布伦',
    duration: '127分钟',
    description: '亿万富翁哈蒙德在一座小岛上利用恐龙DNA打造了一座史前主题公园——"侏罗纪公园"。在一次预展中，由于员工破坏安全系统，恐龙们逃脱了控制，游客们陷入了生死逃亡。斯皮尔伯格用革命性的CGI技术和出色的叙事节奏，创造了影史最具影响力的科幻冒险电影之一。',
    image: 'https://readdy.ai/api/search-image?query=Jurassic%20Park%20movie%20poster%20style%2C%20massive%20t-rex%20silhouette%20with%20park%20entrance%20gate%2C%20tropical%20jungle%20atmosphere%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20adventure%20feel%2C%20minimalist%20design%20with%20logo&width=800&height=1200&seq=movie-jurassic&orientation=portrait',
    featured: false,
  },
  {
    id: 11,
    title: '沉默的羔羊',
    titleEn: 'The Silence of the Lambs',
    slug: 'silence-of-the-lambs',
    category: 'thriller',
    categoryName: '悬疑惊悚',
    year: 1991,
    rating: 9.2,
    director: '乔纳森·戴米',
    cast: '朱迪·福斯特、安东尼·霍普金斯',
    duration: '118分钟',
    description: 'FBI实习生克拉丽斯·斯塔林为了追查连环杀手"野牛比尔"，不得不求助于被关押在精神病院的天才食人魔汉尼拔·莱克特博士。两人之间展开了一场惊心动魄的心理博弈。安东尼·霍普金斯仅用十六分钟的出场时间就塑造了影史最令人不寒而栗的反派形象。',
    image: 'https://readdy.ai/api/search-image?query=The%20Silence%20of%20the%20Lambs%20movie%20poster%20style%2C%20death%20moth%20on%20pale%20face%2C%20dark%20psychological%20thriller%20atmosphere%2C%20red%20and%20black%20color%20palette%2C%20cinematic%20composition%2C%20minimalist%20horror%20design&width=800&height=1200&seq=movie-silence-lambs&orientation=portrait',
    featured: false,
  },
  {
    id: 12,
    title: '楚门的世界',
    titleEn: 'The Truman Show',
    slug: 'the-truman-show',
    category: 'drama',
    categoryName: '经典剧情',
    year: 1998,
    rating: 9.1,
    director: '彼得·威尔',
    cast: '金·凯瑞、劳拉·琳妮、艾德·哈里斯',
    duration: '103分钟',
    description: '楚门·伯班克从出生起就生活在一个巨大的真人秀摄影棚中，他周围的一切——妻子、朋友、同事——都是演员，而他对此一无所知。当他开始察觉到生活中种种不寻常的细节后，他决定寻找真相，逃离这个虚假的世界。金·凯瑞贡献了他职业生涯最动人的表演。',
    image: 'https://readdy.ai/api/search-image?query=The%20Truman%20Show%20movie%20poster%20style%2C%20man%20looking%20up%20at%20sky%20through%20artificial%20dome%2C%20surreal%20atmosphere%2C%20bright%20idealistic%20suburban%20setting%2C%20cinematic%20composition%2C%20minimalist%20design%2C%20warm%20pastel%20colors&width=800&height=1200&seq=movie-truman&orientation=portrait',
    featured: false,
  },
];

export const categories = [
  { slug: 'action', name: '动作大片', icon: 'ri-sword-line', description: '好莱坞顶级动作巨制，肾上腺素飙升的视觉盛宴' },
  { slug: 'sci-fi', name: '科幻巨制', icon: 'ri-rocket-line', description: '探索未来世界与未知宇宙的科幻经典' },
  { slug: 'thriller', name: '悬疑惊悚', icon: 'ri-ghost-line', description: '烧脑悬疑与心理惊悚的极致体验' },
  { slug: 'romance', name: '爱情经典', icon: 'ri-heart-line', description: '感人至深的欧美浪漫爱情故事' },
  { slug: 'drama', name: '经典剧情', icon: 'ri-film-line', description: '影史不朽的剧情经典之作' },
];

export const getMoviesByCategory = (slug: string) => {
  return movies.filter((m) => m.category === slug);
};

export const getMovieById = (id: number) => {
  return movies.find((m) => m.id === id);
};

export const getMovieBySlug = (slug: string) => {
  return movies.find((m) => m.slug === slug);
};

export const getFeaturedMovies = () => {
  return movies.filter((m) => m.featured);
};

export const getRelatedMovies = (currentId: number, category: string, limit: number = 4) => {
  return movies.filter((m) => m.id !== currentId && m.category === category).slice(0, limit);
};